<template>
  <div class="page-container">
    <div class="query-title">选择经销商</div>
  <div class="content">
    <!-- <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" /> -->
    <div class="table-container">
      <Table-filter
        title="经销商列表"
        :rt-columns="rtColumns1"
        :lt-columns="ltColumns1"
        :grid-columns="gridOptions.columns"
        :count-data="countFileds"
        :all-options="allOptions"
        @confirm="tableConfigConfirm"
      >
        <!-- <template #button>
          <table-button name="export" tip="确定" @click="changeStatus()" />
        </template> -->
        <vxe-grid
          ref="xTable"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          height="300"
          max-height="600"
          align="center"
          size="mini"
          show-overflow
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :sort-config="{ multiple: true }"
          :empty-render="{name: 'NotData'}"
          :filter-config="{ remote: true }"
          :toolbar-config="{ custom: true, size: 'mini' }"
        :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          :row-class-name="rowClassName"
          @filter-change="filterChangeEvt"
        >
          <template #action="{ row }">
            <el-link type="primary" size="mini" @click="changeStatus(row)">确认</el-link>
          </template>
        </vxe-grid>
      </Table-filter>
    </div>
  </div>
  <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />
</div>
</template>

<script>
import { getDhk } from '@/api/sap/signing-sap'
import {
  findCustomerByChild
} from '@/api/applyForGoods/index'
import tableMixins from '@/utils/tableMixins'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
mixins: [tableMixins],
components: {
},
data() {
  return {
    searchField: {},
    pagination: {
      page: 1,
      pagesize: 50,
      totalCount: 0
    },
    loading: false,
    gridOptions: {
      columns: [
        // { type: 'radio', field: 'radio', title: '', width: 60 },
        { field: 'customerCode', title: '经销商编码' },
        { field: 'customerName', title: '经销商名称' },
        { field: 'action', title: '操作', slots: { default: 'action' }, width: 80  }
      ],
      data: []
    },
    showDialog: false,
    modeType: '',
    checkData: [],
    totalAmount: 0,
    confirmBtn: ''
  }
},
props: {
},
created() {
  this.queryData()
},
methods: {
  async changeStatus(row) {
    // const data = this.$refs.xTable.getRadioRecord()
    console.log(`output->data`,row)
    this.$emit('changeActive', 'query', row)
  },
  handleTablePaginationChange(pages) {
    Object.assign(this.pagination, pages)
    this.queryData()
  },
  async queryData(page, ranges) {
    if (page === 1) {
      this.pagination.page = page
      if (ranges) {
        // 保存 查询组件的查询参数
        this.ranges = ranges
        this.handleRanges(ranges)
      }
      this.isSetFilter = false
    }
    // console.log(`output->`,this.$store.getters.role,this.$store.getters.userInfo)
    const params = {
      user_bp: this.$store.getters.userInfo.code,
      role: this.$store.getters.role.ROLE,
      ...this.pagination,
      is_result: 1,
      ...this.allConditions,
    }
    this.loading = true
    try {
      const { data} = await findCustomerByChild(params)
      if (data.length === 0 && (total - 0)) {
        this.queryData(1, ranges)
        return
      }
      // 更新计算值
      this.updateCount()
      if (this.showHeader) {
        this.gridOptions.data = this.tableCountData.concat(data)
      } else {
        this.gridOptions.data = data.concat(this.tableCountData)
      }
      this.setFilter()
    } catch (e) {
      //
    }
    this.loading = false
  },
},

}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/selectAgent.vue